/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Filter_FavoritesInputs */

const en_us2_exercise_personal_filter_favorites = /** @type {(inputs: Exercise_Personal_Filter_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favourites`)
};

const pt_br2_exercise_personal_filter_favorites = /** @type {(inputs: Exercise_Personal_Filter_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favoritos`)
};

const es_419_exercise_personal_filter_favorites = /** @type {(inputs: Exercise_Personal_Filter_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favoritos`)
};

const pt_pt2_exercise_personal_filter_favorites = /** @type {(inputs: Exercise_Personal_Filter_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favoritos`)
};

const fr_fr2_exercise_personal_filter_favorites = /** @type {(inputs: Exercise_Personal_Filter_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favoris`)
};

const de_de2_exercise_personal_filter_favorites = /** @type {(inputs: Exercise_Personal_Filter_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favoriten`)
};

const it_it2_exercise_personal_filter_favorites = /** @type {(inputs: Exercise_Personal_Filter_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferiti`)
};

/**
* | output |
* | --- |
* | "Favourites" |
*
* @param {Exercise_Personal_Filter_FavoritesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_filter_favorites = /** @type {((inputs?: Exercise_Personal_Filter_FavoritesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Filter_FavoritesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_filter_favorites(inputs)
	if (locale === "es-419") return es_419_exercise_personal_filter_favorites(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_filter_favorites(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_filter_favorites(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_filter_favorites(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_filter_favorites(inputs)
	return en_us2_exercise_personal_filter_favorites(inputs)
});
export { exercise_personal_filter_favorites as "exercise-personal.filter_favorites" }